import React from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

const SelectLinkType = () => {
  const navigate = useNavigate();

  const linkTypes = [
    {
      id: "one-on-one",
      icon: "👤",
      title: "1-on-1 invite",
      description: "Let an invitee pick a time to meet with you. Best for booking sales calls and service appointments.",
      onClick: () => navigate("/calendar/create-invite/one-on-one")
    },
    {
      id: "group",
      icon: "👥",
      title: "Group invite",
      description: "Let multiple invitees meet with you at the same time. Best for booking webinars and classes.",
      onClick: () => navigate("/calendar/create-invite/group")
    },
    {
      id: "poll",
      icon: "📊",
      title: "Meeting poll",
      description: "Find out when everyone is free by asking them to vote on times. Best for coordinating conference calls and team meetings.",
      onClick: () => navigate("/calendar/create-invite/poll")
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 py-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Select new link type
          </h1>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-5xl mx-auto">
          {linkTypes.map((type, index) => (
            <motion.button
              key={type.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              whileHover={{ y: -8, transition: { duration: 0.2 } }}
              onClick={type.onClick}
              className="apple-card apple-hover-lift text-left p-6 transition-all group"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="text-4xl text-primary-600">
                  {type.icon}
                </div>
                <h2 className="text-xl font-bold text-gray-900 group-hover:text-primary-600 transition-colors">
                  {type.title}
                </h2>
              </div>

              {/* Visual representation */}
              <div className="mb-6 bg-gray-50 rounded-lg p-4 h-32 flex items-center justify-center">
                {type.id === "one-on-one" && (
                  <div className="w-full space-y-2">
                    <div className="text-xs text-gray-500 mb-2">Select date and time</div>
                    <div className="flex gap-1">
                      {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                        <div key={i} className="w-6 h-6 bg-gray-200 rounded"></div>
                      ))}
                    </div>
                    <div className="flex gap-1">
                      {[1, 2, 3].map((i) => (
                        <div key={i} className="h-2 bg-gray-300 rounded flex-1"></div>
                      ))}
                    </div>
                  </div>
                )}
                {type.id === "group" && (
                  <div className="w-full space-y-2">
                    <div className="text-xs text-gray-500 mb-2">Select date and time</div>
                    <div className="flex gap-1">
                      {[1, 2, 3, 4, 5, 6, 7].map((i) => (
                        <div key={i} className="w-6 h-6 bg-gray-200 rounded"></div>
                      ))}
                    </div>
                    <div className="flex gap-1">
                      {[1, 2, 3].map((i) => (
                        <div key={i} className="h-2 bg-gray-300 rounded flex-1"></div>
                      ))}
                    </div>
                  </div>
                )}
                {type.id === "poll" && (
                  <div className="w-full space-y-2">
                    <div className="text-xs text-gray-500 mb-2">Select all available times</div>
                    <div className="grid grid-cols-5 gap-1">
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
                        <div key={i} className="h-8 bg-gray-200 rounded"></div>
                      ))}
                    </div>
                  </div>
                )}
              </div>

              <p className="text-sm text-gray-600 leading-relaxed">
                {type.description}
              </p>
            </motion.button>
          ))}
        </div>

        <div className="text-center mt-12">
          <button
            onClick={() => navigate("/calendar/booking-pages")}
            className="apple-btn-secondary"
          >
            ← Back to Booking Pages
          </button>
        </div>
      </div>
    </div>
  );
};

export default SelectLinkType;
